// Error: Reference.set failed: First argument contains undefined in property 'users.undefined.id'

import * as t from './actionTypes';

const initialState = { isLoading: false, users: [], selectedUser: '' };

const userReducer = (state = initialState, action) => {
  // reducer switch statement
  switch (action.type) {
    // set busy
    case t.SET_BUSY:
      return Object.assign({}, state, { isLoading: true });
    // unset busy
    case t.UNSET_BUSY:
      return Object.assign({}, state, { isLoading: false });
    // user load success
    case t.USER_LOAD_SUCCESS:
      var users = action.users;
      var userArr = [];
      for (var user in users) {
        userArr.push(users[user]);
      }
      state = Object.assign({}, state, { users: userArr });
      return state;
    // select user
    case t.SELECT_USER:
      var userId = action.payload;
      return Object.assign({}, state, { selectedUser: userId });
    // default
    default:
      return state;
    }
};

export default userReducer;
